import React from 'react';
import { useComponentTranslations } from '@core/js/hooks/component';
import { useGameImageUrls } from '@core/js/hooks/games';
import { Image } from '@core/js/components/common/Image';
import { useOpenGame } from '@theme/js/components/main/TopWinners/hooks/useOpenGame';

import style from './WinnerItem.scss';

export const WinnerItem = (props) => {
    const translate = useComponentTranslations();
    const { gameCode: code, gameName, player, winAmount, className, tableItemRef } = props;
    const imageUrls = useGameImageUrls({ code });

    const openGame = useOpenGame(code);

    return <div className={`${style.container} ${className}`} onClick={openGame} ref={tableItemRef}>
        <Image
            alt={gameName}
            src={imageUrls}
            className={style.image}
        />
        <div className={style.info}>
            <div className={style.gameName}>{gameName}</div>
            <div className={style.nickname}>{player}</div>
            <div className={style.amount}><span className={style.amountLabel}>{translate('won')}: </span>{winAmount}</div>
        </div>
    </div>;
};
